module.exports = __webpack_public_path__ + "static/media/MAIN_PAGE_IMAGE_2.5523d4a6.jpg";